import React from "react";

import PeakDates from "./PeakDates";

const BlackoutDates = (props) => {
  const blackoutDates = props.blackoutDates;

  return (
    <div>
      <h2>Peak Dates</h2>
      {blackoutDates.length > 0 ? (
        <table className="peakDatesTable">
          <tr className="tableHeader">
            <th className="tableCell">Peak Start Date</th>
            <th className="tableCell">Peak End Date</th>
          </tr>
          <PeakDates blackoutDates={blackoutDates} />
        </table>
      ) : (
        <div
          style={{
            color: "green",
            fontSize: "1.5rem",
            textAlign: "center",
          }}
        >
          No Peak Dates
        </div>
      )}
    </div>
  );
};

export default BlackoutDates;
